'use client';
import React from 'react';
import { Button, ThemeProvider } from '@mui/material';
import theme from '@/app/(signup)/theme';
import { usePopups, PopupTypes } from '@/providers/popups';

const SubscribeDrawerButton = () => {
  const { openPopup } = usePopups();

  const handleOpen = () => openPopup(PopupTypes.NewsletterSubscription);

  return (
    <ThemeProvider theme={theme}>
      <Button variant='contained' onClick={handleOpen}>
        SUBSCRIBE
      </Button>
    </ThemeProvider>
  );
};

export default SubscribeDrawerButton;
